export default __webpack_public_path__ + "static/media/north-america-countries.bdac8833.geojson";